<template>
  <tr
    :class="{
      thead: isExpand,
      highlighted: isHighlight
    }"
    @dblclick="Table.$emit('row-dblclick', row)"
    @click="onClick"
  >
    <table-cell v-for="col in Table.cols" :key="col.prop || col.type" :row="row" :col="col" />
  </tr>
</template>

<script>
  import TableCell from './TableCell'

  // 列表 - 行
  export default {
    name: 'TableRow',
    components: { TableCell },
    inject: ['Table'],
    provide() {
      return { Row: this }
    },
    props: {
      row: {
        type: Object,
        required: true
      },

      index: Number
    },

    computed: {
      id() {
        return this.Table.getRowId(this.row)
      },

      isExpand() {
        return this.Table.expandId === this.id
      },

      isHighlight() {
        return this.Table.selectedRow === this.row
      },

      isSelected() {
        return this.Table.isRowSelected(this.row)
      },

      selectable() {
        return this.Table.rowSelectable(this.row)
      }
    },

    methods: {
      onClick(e) {
        const { row, Table } = this
        Table.$emit('row-click', row, e)

        // 单选
        if (Table.selectable === 'single') {
          Table.select(row, row !== Table.selectedRow)
        }
      }
    }
  }
</script>
